import React from "react";
import contactUsimag from "../../assets/contactusImage.jpg";
import FAQSection from "./FAQSection";
import ContactForm from "./ContactForm";
import { SocketProvider } from "../../context/SocketContext";
import Chat from "./Chat";
import { useSelector } from "react-redux";
import api from "../../utils/api";
const ContactUs = () => {
  const { isAuthenticated, user, loading } = useSelector((state) => state.user);
    const RestaurantSavedId = JSON.parse(localStorage.getItem("selectedRestaurantId"));
    const [locationData, setLocationData] = React.useState([]);
  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(`/restaurant/${RestaurantSavedId}`);
        const results = response?.data?.data || [];
        setLocationData(results);
      } catch (error) {
        console.error("Error fetching restaurant data:", error);
      }
    };
    fetchData();
  }, [RestaurantSavedId]);

  return (
    <>
      {/* Header Section */}
      <div className="w-full h-[146px] bg-[#AF313D]  flex flex-col text-center text-white">
        <div>
          <h1 className="font-bold text-[40px] sm:text-[60px] body">
            Contact Us
          </h1>
          <p className="font-medium text-[16px] sm:text-[23px] body">
            Get closer to know us
          </p>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="max-w-[90%] mx-auto min-h-screen mt-12">
        <div className="flex flex-col sm:flex-row gap-6">
          {/* Left Section (Image) */}
          <div className="flex-1 mt-10">
            <img
              src={contactUsimag}
              alt="Contact Us"
              className="w-full h-auto object-cover rounded-lg"
            />
          </div>

          {/* Right Section (Button and Contact Info) */}
          <div className="flex-1">
            <div className="relative">
              {/* Live Chat Button */}
              {/* <button className="bg-[#AF313D] text-white w-[198px] h-[55px] mt-2 md:mt-6 gap-2 flex items-center justify-center rounded-full text-sm font-medium hover:bg-red-700 absolute top-0 right-0  mr-2">
                <div className="bg-[#9DFF00] w-4 h-4 rounded-full mt-1"></div>
                <span className="font-bold text-[30px] body">Live Chat</span>
              </button> */}
            </div>
            <div className="mt-20 ml-20">
              {/* Contact Info Section */}
              <div className="flex flex-col gap-10">
                <p className="text-[#A46C32] font-inter text-[16px] body leading-[24px] tracking-[4px]">
                  CONTACT
                </p>
                <p className="font-semibold text-[32px] sm:text-[64px] body leading-[42px] sm:leading-[72px] tracking-[0] mr-0">
                  Find us here
                </p>
                {/* Contact Information */}
                <div>
                  {/* Phone */}
                  <div className="flex justify-between">
                    <h1 className="body font-semibold text-[16px] sm:text-[20px] leading-[24px] sm:leading-[30px] tracking-[0]">
                      Phone
                    </h1>
                    <a
                      href="tel:+447554445603"
                      className="body font-semibold text-[16px] sm:text-[20px] leading-[24px] sm:leading-[30px] tracking-[0] text-[#321D1D] hover:underline"
                    >
                      {locationData?.phone}
                    </a>
                  </div>
                  <div className="w-full mt-4">
                    <hr className="border-t-[2px] border-[#737373]" />
                  </div>

                  {/* Social Media */}
                  <div className="flex justify-between mt-8">
                    <h1 className="body font-semibold text-[16px] sm:text-[20px] leading-[24px] sm:leading-[30px] tracking-[0]">
                      Social
                    </h1>
                    <a
                      href={`${locationData?.instagram}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="body font-semibold text-[16px] sm:text-[20px] leading-[24px] sm:leading-[30px] tracking-[0] text-[#321D1D] hover:underline"
                    >
                      {locationData?.instagram}
                    </a>
                  </div>
                  <div className="w-full mt-4">
                    <hr className="border-t-[2px] border-[#737373]" />
                  </div>

                  {/* Email */}
                  <div className="flex justify-between mt-8">
                    <h1 className="body font-semibold text-[16px] sm:text-[20px] leading-[24px] sm:leading-[30px] tracking-[0]">
                      Email
                    </h1>
                    <a
                      href="mailto:fastfood@levantecuisine.co.uk"
                      className="body font-semibold text-[16px] sm:text-[20px] leading-[24px] sm:leading-[30px] tracking-[0] text-[#321D1D] hover:underline"
                    >
                       {locationData?.email}
                    </a>
                  </div>
                  <div className="w-full mt-4">
                    <hr className="border-t-[2px] border-[#737373]" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FAQSection />
        <ContactForm nameOfStore={locationData?.title} />
      </div>
    </>
  );
};

export default ContactUs;
